import script from "./ManageSubhiresModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSubhiresModal.vue?vue&type=script&setup=true&lang=js"

import "./ManageSubhiresModal.vue?vue&type=style&index=0&id=3d5efa16&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5efa16"]])

export default __exports__